import styled from 'styled-components'

export const Container = styled.div.attrs({
  className: 'authflow-country-prefix-select',
})`
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: sans-serif;
`

export const CountryPrefixSelectContainer = styled.div.attrs({
  className: 'authflow-country-prefix-select-container',
})`
  position: relative;
  display: flex;
  width: 100%;
`

export const CountryFlag = styled.span`
  display: inline-block;
  width: 32px;
  height: 19px;
  margin-right: 10px;
  border: 1px solid #bebebe;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover !important;
  }
`

export const CountryItemInner = styled.div.attrs({
  className: 'authflow-country-select-item',
})`
  display: flex;
  width: 100%;
`
